import NetworkingOperations from "../index";

const SMSChangeLang = (data) => {
	const url = process.env.REACT_APP_SMS_CHANGE_LANG;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default SMSChangeLang;
